import React from 'react'
import { CompPedido } from '../../../Complex'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'

import './stylesCPA.css'

export default function CompProxAgend() {
  const { userUCtx } = React.useContext(UsuarioContext)

  const [title, setTitle] = React.useState('')

  React.useEffect(() => {
    if (userUCtx.ultimoPedido !== null) {
      VerificaAgendamento(userUCtx.ultimoPedido)
    }
  }, [userUCtx.ultimoPedido])

  function VerificaAgendamento(pedido) {
    const data = new Date()
    const dataAgend = new Date(pedido.dataInicio)
    if (dataAgend > data) {
      if (pedido.status === 'SOLICITADO' || pedido.status === 'AGENDADO')
        setTitle('Próximo na sua agenda')
      else if (pedido.status === 'CANCELADO') setTitle('Seu agendamento foi cancelado')
    } else {
      setTitle('Último agendamento')
    }
  }

  return (
    <div className='contain-prox-agend'>
      {<p>{title}</p>}
      {userUCtx.ultimoPedido !== null && <CompPedido pedido={userUCtx.ultimoPedido} />}
    </div>
  )
}
